import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { CommonService } from '../../services/common/common.service';
import { ResetPassErrorConstants } from '../../constants/error-messages';
import { CommonLabelConstant, ResetPassLabelConstants } from '../../constants/label-constants';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { StorageService } from '../../services/storage/storage.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})

export class ChangePasswordComponent {

  isLoading: boolean = false;
  resetPasswordForm!: FormGroup;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  showCurrentPasseword: boolean = false;
  submitted: boolean = false;
  errorConstants: any;
  labelConstants: any;
  commonConstants: any;
  userId: string = '';
  showRequirements: boolean = false;
  requirements = {
    lowercase: false,
    uppercase: false,
    number: false,
    specialChar: false,
    length: false,
  };

  constructor(
    private readonly fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly api: ApiUrlHelper,
    private readonly commonService: CommonService,
    public modalServices: NgbActiveModal,
    private readonly storageService: StorageService,
    private readonly router: Router
  ) {
    const passwordPattern = /^(?=.*[A-Za-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&\-_^()+={}|\\/<>,.;:'~`])[A-Za-z\d@$!%*#?&\-_^()+={}|\\/<>,.;:'~`]{8,}$/;
    this.resetPasswordForm = this.fb.group(
      {
        CurrentPassword: ['', Validators.required],
        NewPassword: [
          '',
          [Validators.required, Validators.pattern(passwordPattern)],
        ],
        ConfirmNewPassword: ['', [Validators.required]],
      },
      {
        validator: this.passwordMatchValidator,
      }
    );
  }

  passwordMatchValidator(formGroup: FormGroup): { [key: string]: boolean } | null {
    const newPassword = formGroup.get('NewPassword')?.value;
    const confirmPassword = formGroup.get('ConfirmNewPassword')?.value;
    return newPassword && confirmPassword && newPassword !== confirmPassword ? { mismatch: true } : null;
  }

  ngOnInit(): void {
    this.errorConstants = ResetPassErrorConstants;
    this.labelConstants = ResetPassLabelConstants;
    this.commonConstants = CommonLabelConstant;
  }

  get changePassControls() {
    return this.resetPasswordForm.controls;
  }

  togglePasswordVisibility(fieldName: string) {
    (this as any)[fieldName] = !(this as any)[fieldName];
  }

  togglePasswordRequirements(show: boolean) {
    this.showRequirements = show;
  }

  checkPasswordValidity() {
    const newPassword = this.changePassControls['NewPassword'].value || '';
    this.requirements.lowercase = /[a-z]/.test(newPassword);
    this.requirements.uppercase = /[A-Z]/.test(newPassword);
    this.requirements.number = /[0-9]/.test(newPassword);
    this.requirements.specialChar = /[!@#\$%^&*]/.test(newPassword);
    this.requirements.length = newPassword.length >= 8;
  }

  submitResetPassForm() {
    this.submitted = true;
    if (this.resetPasswordForm.valid) {
      this.submitted = false;
      this.isLoading = true;
      let api = this.api.apiUrl.ChangePassword.ChangePassword;
      let passwordChangeRequestModel = {
        CurrentPassword: this.resetPasswordForm.value.CurrentPassword?.trim(),
        NewPassword: this.resetPasswordForm.value.NewPassword?.trim(),
        ConfirmPassword:
          this.resetPasswordForm.value.ConfirmNewPassword?.trim(),
      };
      this.commonService.doPost(api, passwordChangeRequestModel).pipe().subscribe({
        next: (response) => {
          if (response.success) {
            this.toastr.success(response.message);
            this.modalServices.close('cancel');
            this.storageService.clearStorage();
            this.isLoading = false;
            this.router.navigate(['/login']);
          } else {
            this.toastr.error(response.message);
            this.isLoading = false;
          }
        },
        error: (err) => {
          this.isLoading = false;
        },
      });
    }
  }

  onClose(type: string) {
    this.modalServices.close(type);
  }
}